import { Space, Steps, Typography } from "antd";
import '@xyflow/react/dist/style.css';
import { useEffect, useState } from "react";
import "@silevis/reactgrid/styles.css";
import { Route, Switch, useHistory, useParams } from "react-router-dom";
import { Categorize } from "./Categorize";
import { Filter } from "./Filter";
import { Selection } from "./Selection";
import { Evaluation } from "./Evaluation";
import { Results } from "./Results";
import { useDispatch } from "react-redux";
import { analysisDetailsRequest } from "src/store/actions/operations";
import { InfoCircleOutlined } from "@ant-design/icons";

enum STEPS { categorize, filter, selection, evalution, results }

const steps = [
  { title: "Initialise Data", description: <Space><InfoCircleOutlined /><Typography.Text type="secondary">View and Input Categories and Sub-Categories</Typography.Text></Space> },
  { title: "Input Settings", description: <Space><InfoCircleOutlined /><Typography.Text type="secondary">Input Categorisation</Typography.Text></Space> },
  { title: "Selection of Model", description: <Space><InfoCircleOutlined /><Typography.Text type="secondary">Filter and Select Model</Typography.Text></Space> },
  { title: "Model Testing Data Input", description: <Space><InfoCircleOutlined /><Typography.Text type="secondary">Input Evaluation Points</Typography.Text></Space> },
  {
    title: "Model Testing",
    description: (<>
      <Space><InfoCircleOutlined /><Typography.Text type="secondary">Initiate Forward Predition</Typography.Text></Space>
      <Space><InfoCircleOutlined /><Typography.Text type="secondary">Evaluate Results</Typography.Text></Space>
    </>)
  },
]

export const AnalysisDetails = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      console.log("unmount")
    }
  }, [])

  const { opid, anid, step } = useParams<{ opid: string, anid: string, step: string }>()

  useEffect(() => {
    dispatch(analysisDetailsRequest(anid))
  }, [anid, dispatch])

  const [currentStep, setCurrentStep] = useState(() => {
    switch (step) {
      case "categorize": return STEPS.categorize
      case "filter": return STEPS.filter
      case "selection": return STEPS.selection
      case "evaluation": return STEPS.evalution
      case "results": return STEPS.results
      default: return STEPS.categorize
    }
  })

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleStepChange = (step: number) => {
    setCurrentStep(step)
  }
  const { push } = useHistory()

  useEffect(() => {
    switch (currentStep) {
      case STEPS.categorize: push(`/ai-engine/operations/${opid}/analysis/${anid}/categorize`)
        break;

      case STEPS.filter: push(`/ai-engine/operations/${opid}/analysis/${anid}/filter`)
        break;

      case STEPS.selection: push(`/ai-engine/operations/${opid}/analysis/${anid}/selection`)
        break;

      case STEPS.evalution: push(`/ai-engine/operations/${opid}/analysis/${anid}/evaluation`)
        break;

      case STEPS.results: push(`/ai-engine/operations/${opid}/analysis/${anid}/results`)
        break;

      default:
        break;
    }
  }, [anid, currentStep, opid, push])

  return (
    <div style={{ marginBottom: 100 }}>
      <div style={{ padding: 32, backdropFilter: "blur(10px)", position: "sticky", top: 0, background: "#ffffff40", zIndex: 5, marginInline: -24 }}>
        <Steps
          size="small"
          current={currentStep}
          items={steps}
          onChange={handleStepChange}
        />
      </div >
      <Switch>
        <Route path="/ai-engine/operations/:opid/analysis/:anid/categorize">
          <Categorize currentStep={currentStep} previous={prev} next={next} steps={steps} />
        </Route>
        <Route path="/ai-engine/operations/:opid/analysis/:anid/filter">
          <Filter currentStep={currentStep} previous={prev} next={next} steps={steps} />
        </Route>
        <Route path="/ai-engine/operations/:opid/analysis/:anid/selection">
          <Selection currentStep={currentStep} previous={prev} next={next} steps={steps} />
        </Route>
        <Route path="/ai-engine/operations/:opid/analysis/:anid/evaluation">
          <Evaluation currentStep={currentStep} previous={prev} next={next} steps={steps} />
        </Route>
        <Route path="/ai-engine/operations/:opid/analysis/:anid/results">
          <Results currentStep={currentStep} previous={prev} next={next} steps={steps} />
        </Route>
      </Switch>
    </div>
  )
}
